var _defs, _path, _path2, _path3, _circle, _circle2, _circle3, _text, _text2, _g, _text3, _path4, _path5, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 40,
    viewBox: "0 0 160 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logoGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00ff4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00cc44"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    height: "300%",
    width: "300%",
    x: "-100%",
    y: "-100%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "blur",
    operator: "over"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "textGlow",
    x: "-10%",
    y: "-10%",
    width: "120%",
    height: "120%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00ff4c",
    floodOpacity: 0.3,
    result: "glowColor"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "glowColor",
    in2: "blur",
    operator: "in",
    result: "softGlow"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "softGlow",
    in2: "SourceGraphic",
    operator: "over"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4 L28 8 L28 17 C28 24 24 29 20 32 C16 29 12 24 12 17 L12 8 Z",
    fill: "none",
    stroke: "#00ff4c",
    strokeWidth: 0.8,
    opacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 20 H10 M30 20 H38 M20 4 V1",
    stroke: "#00ff4c",
    strokeWidth: 0.8,
    opacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8 H5 M28 8 H35",
    stroke: "#00ff4c",
    strokeWidth: 0.5,
    opacity: 0.6,
    strokeDasharray: "1,1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 20,
    r: 1.5,
    fill: "#00ff4c",
    opacity: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 20,
    r: 1.5,
    fill: "#00ff4c",
    opacity: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 1,
    r: 1,
    fill: "#00ff4c",
    opacity: 0.9
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 7,
    y: 16,
    fontFamily: "JetBrains Mono, monospace",
    fontSize: 2.5,
    fill: "#00ff4c",
    opacity: 0.5
  }, "010110")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 26,
    y: 16,
    fontFamily: "JetBrains Mono, monospace",
    fontSize: 2.5,
    fill: "#00ff4c",
    opacity: 0.5
  }, "101001")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14, 10) scale(0.6)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 13,
    width: 16,
    height: 12,
    rx: 2,
    fill: "url(#logoGradient)",
    filter: "url(#glow)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 13 V9 C9 5.7 11.7 3 15 3 C18.3 3 21 5.7 21 9 V13",
    stroke: "#ffffff",
    strokeWidth: 2.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 19,
    r: 2,
    fill: "#ffffff"
  }))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 43,
    y: 24,
    fontFamily: "JetBrains Mono, sans-serif",
    fontWeight: "bold",
    fontSize: 16,
    fill: "#ffffff",
    filter: "url(#textGlow)"
  }, "\n    KINFHERTIX\n  ")), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43 27 H138",
    stroke: "#00ff4c",
    strokeWidth: 0.5,
    opacity: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43 27 L48 32 M138 27 L133 32",
    stroke: "#00ff4c",
    strokeWidth: 0.5,
    opacity: 0.7
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 27,
    r: 1,
    fill: "#00ff4c",
    opacity: 0.9
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 27,
    r: 1,
    fill: "#00ff4c",
    opacity: 0.9
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 27,
    r: 0.7,
    fill: "#00ff4c",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.2;0.8;0.2",
    dur: "4s",
    repeatCount: "indefinite"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 27,
    r: 0.7,
    fill: "#00ff4c",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.2;0.8;0.2",
    dur: "3s",
    repeatCount: "indefinite",
    begin: "1s"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 27,
    r: 0.7,
    fill: "#00ff4c",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.2;0.8;0.2",
    dur: "5s",
    repeatCount: "indefinite",
    begin: "2s"
  }))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 27,
    r: 0.7,
    fill: "#00ff4c",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.2;0.8;0.2",
    dur: "4s",
    repeatCount: "indefinite",
    begin: "0.5s"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.343e9e3a03053bfae34e3189a20d9301.svg";
export { ForwardRef as ReactComponent };